import * as React from 'react';
import { createContext, useContext } from 'react';

const BulkQuestionsUrl = createContext<BulkQuestionUrl>(null);

type BulkQuestionUrl = ({ quizId }: { quizId: string }) => string;

interface Props {
  bulkQuestionsUrl: BulkQuestionUrl;
  children: React.ReactNode;
}

export function BulkQuestionsUrlProvider({
  bulkQuestionsUrl,
  children,
}: Props) {
  return (
    <BulkQuestionsUrl.Provider value={bulkQuestionsUrl}>
      {children}
    </BulkQuestionsUrl.Provider>
  );
}

export function useBulkQuestionsUrl() {
  const context = useContext(BulkQuestionsUrl);
  if (context == undefined) {
    throw new Error(
      'useBulkQuestionsUrl must be used inside of a BulkQuestionsUrlProvider'
    );
  }
  return context;
}
